import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProducts = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "#748094",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.2,
		d: "M8.272 15.395a1.5 1.5 0 0 1-2.123.002l-3.211-3.21a1.5 1.5 0 0 1 0-2.122l5.415-5.413a1.67 1.67 0 0 1 1.178-.488h2.971c.921 0 1.668.747 1.668 1.668v2.966c0 .442-.176.866-.488 1.178z",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "#748094",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.2,
		d: "M17.504 6.665v3.166c0 .442-.176.866-.489 1.18l-4.72 4.72"
	})]
});
export default SvgProducts;
